import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Preview Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '14px',
          fontFamily: 'Arial, sans-serif'
        }}>
          <div style={{ marginBottom: '10px' }}>
            ⚠️ Preview rendering error
          </div>
          <div style={{ fontSize: '12px', color: '#999' }}>
            Schema structure may be invalid. Please check the popup configuration.
          </div>
          {import.meta.env.DEV && (
            <details style={{ marginTop: '10px', textAlign: 'left' }}>
              <summary style={{ cursor: 'pointer', color: '#007acc' }}>
                Error Details
              </summary>
              <pre style={{ 
                fontSize: '11px', 
                color: '#666', 
                background: '#f5f5f5', 
                padding: '10px',
                marginTop: '5px',
                overflow: 'auto'
              }}>
                {this.state.error?.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 